module.exports = __webpack_public_path__ + "static/03_Retrieve-records-compressed-d3bcb7a9b9172feb4fa0e31918803ac1.jpg";